/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Status_Past_DueInputs */

const en_plan_status_past_due = /** @type {(inputs: Plan_Status_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past due`)
};

const es_plan_status_past_due = /** @type {(inputs: Plan_Status_Past_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vencida`)
};

/**
* | output |
* | --- |
* | "Past due" |
*
* @param {Plan_Status_Past_DueInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_status_past_due = /** @type {((inputs?: Plan_Status_Past_DueInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Status_Past_DueInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_status_past_due(inputs)
	return en_plan_status_past_due(inputs)
});